import { SITE_URL } from '../components/Seo';

// LocalBusiness / ProfessionalService schema for the homepage.
export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#business`,
  name: 'Simply Gold Productions',
  description:
    'Kelowna video production company creating commercial, sports, documentary, drone and trades films for brands across BC and Vancouver.',
  url: SITE_URL,
  email: 'charles@simplygoldproductions.com',
  telephone: '+1-778-996-0446',
  image: `${SITE_URL}/og-image.jpg`,
  logo: `${SITE_URL}/sgp-logo.png`,
  priceRange: '$$',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '2218 Shannon Woods Pl',
    addressLocality: 'Kelowna',
    addressRegion: 'BC',
    postalCode: 'V4T 2L9',
    addressCountry: 'CA',
  },
  areaServed: ['Kelowna', 'West Kelowna', 'Vancouver', 'British Columbia'],
  sameAs: [
    'https://www.instagram.com/simplygoldprod/',
    'https://www.facebook.com/SimplyGoldProductions/',
    'https://www.youtube.com/@simplygoldprod',
    'https://www.linkedin.com/in/charles-canaan-38842667',
  ],
};

// BreadcrumbList builder for interior pages.
export const breadcrumb = (name, path) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
    { '@type': 'ListItem', position: 2, name, item: `${SITE_URL}${path}` },
  ],
});
